import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08dd2f7c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd2f7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08dd2f7c')) {
      api.createRecord('08dd2f7c', component.options)
    } else {
      api.reload('08dd2f7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08dd2f7c&scoped=true", function () {
      api.rerender('08dd2f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/ads/advList/index.vue"
export default component.exports